module.exports = __webpack_public_path__ + "img/hot-beverage.dc5dfd43.png";